import Message from "@/utils/message"

export default (error, data) => {

  let options = data || {}

  let response = {
    errorCode: 503,
    errorMessage: "Falha de comunicação",
  }

  if (error.response && error.response.data && error.response.data.errorCode)
    response = error.response.data

  if (options.silent)
    return response  

  if (response.errorCode >= 500) {
    Message.apiError(response.errorMessage, error)
  } else {
    Message.error(response.errorMessage)
  }   

  return response
}